import styled from 'styled-components';
import fonts from 'styles/fonts';
import colors from 'styles/colors';
import sizes from 'styles/sizes';

export const FilterWrap = styled.div`
	border-bottom: 1px solid ${colors.functional.paleGrey};
	display: flex;
	height: 39px;
	margin-bottom: 20px;

	@media (min-width: ${sizes.media.smallMaxWidth + 1}px) {
		display: block;
	}
`;

export const FilterLabel = styled.button`
	color: ${colors.secondary.deepCove};
	flex: 1;
	font-family: ${fonts.primary.regular};
	font-size: 16px;
	height: 41px;
	line-height: 19px;
	letter-spacing: 1px;
	margin: 0;
	padding: 10px 25px 0 25px;
	position: relative;

	&:after {
		content: '';
		position: absolute;
		left: 0;
		bottom: 0;
		display: block;
		margin: 3px auto;
		height: 2px;
		width: 0;
		background: transparent;
		transition: all 0.5s ease-in-out;
		color: ${colors.secondary.deepCove};
	}
	&.active {
		color: ${colors.secondary.deepCove};
		font-family: ${fonts.primary.bold};
	}
	&.active:after {
		width: 100%;
		background: ${colors.secondary.deepCove};
	}
`;
